import {useEffect, useState} from 'react'

export const useDisconnect = (socket) => {
    const [isOnline, setIsOnline] = useState(socket.connected)
    const [disconnectReason, setDisconnectReason] = useState(null)

    useEffect(() => {
        const handleConnect = () => {
            setIsOnline(true)
            setDisconnectReason(null)
        }
        const handleDisconnect = reason => {
            setIsOnline(false)
            setDisconnectReason(reason)
        }
        const handleConnectError = error => {
            console.warn('Socket.IO connection error:', error.message)
            setIsOnline(false)
            setDisconnectReason(error.message)
        }

        socket.on('connect', handleConnect)
        socket.on('disconnect', handleDisconnect)
        socket.on('connect_error', handleConnectError)

        return () => {
            socket.off('connect', handleConnect)
            socket.off('disconnect', handleDisconnect)
            socket.off('connect_error', handleConnectError)
        }
    }, [socket])

    return {isOnline, setIsOnline, disconnectReason}
}

